import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { RenewalFilesService } from 'app/modules/vehicle-inventory/services/renewalFiles.service';
import { Rest } from 'app/rest/rest_client';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { ConfirmationService } from 'primeng/api';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'app-renewal-files',
    templateUrl: './renewal-files.component.html',
    styleUrls: ['./renewal-files.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RenewalFilesComponent extends EntityListComponent<Rest.RenewalFiles>
implements OnInit {

    private timerSubscription: Subscription | null = null; // Store the subscription
@Input() type:string;

disableSave: boolean;


constructor(
    private renewalFilesService: RenewalFilesService,
    protected confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
    protected i18n: I18nService,
    authenticationService: AuthenticationService,
    protected loadingService: LoadingService,
    protected userTime: UserTimePipe,
    protected excelService: ExcelService,
    protected translateService: TranslateService,
) {
    super(
        renewalFilesService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
    );
    this.renewalFilesService = renewalFilesService;
}

ngOnInit() {
    super.ngOnInit();

}


beforeLoad(): void {
    this.paginationRequest.sortBy = "dateFileUpdate";
    this.paginationRequest.sortAsc= false;
    this.paginationRequest.filters['renewalFilesType'] = [this.type]; 
    this.paginationRequest.pageSize = 5;
    if (!this.timerSubscription) {
        this.timerSubscription = timer(10000, 10000).subscribe(() => {
            this.refresh();
          });
    }

}

ngOnDestroy(): void {
    // Ensure we clean up when the component is destroyed
    if (this.timerSubscription) {
        this.timerSubscription.unsubscribe(); // Unsubscribe to stop the timer
        this.timerSubscription = null; // Reset the subscription
      }
  }




}
